import React from 'react';
import c from 'classnames';
import { ReactPaginateProps } from 'react-paginate';

import {
  Pagination,
} from '@uncinc/uncinc-react-kitchen-sink';

import Icon from '../Icon';

import './style.scss';
import useProgrammaticFocus from '../../hooks/useProgrammaticFocus';

type Props = ReactPaginateProps & {
  totalPages: number;
  currentPage: number;
  setCurrentPage: (page: number) => void
};

// @TODO: Customize this pager to the Jellinek version. Should be very similar to this.
const Pager: React.FC<Props> = (props) => {
  const classNames = c('Pager');

  const focusToBody = useProgrammaticFocus(document.body);

  const { setCurrentPage } = props;

  const setCurrentPageHandler = (page: number) => {
    if (setCurrentPage) {
      setCurrentPage(page);
    }

    focusToBody();
  };

  return (
    <Pagination
      containerClassName={classNames}
      previousLabel={<Icon icon="chevron" variant="1" orientation="left" />}
      nextLabel={<Icon icon="chevron" variant="1" />}
      {...props}
      setCurrentPage={setCurrentPageHandler}
    />
  );
};

export default Pager;
